import React, {Component} from "react";
import PropTypes from 'prop-types';
import _ from "lodash";

const propTypes = {
	statusList: PropTypes.array.isRequired,
	setFilters: PropTypes.func.isRequired,
	selected: PropTypes.string
}

class TaskNavigation extends Component {
	render() {
		return (<div className="level tasks">
			<div className="level-left">
				<div className="level-item">
					<h4 className="title is-cdm-title">Tareas</h4>
				</div>
			</div>
			<div className="level-right">
				{_.map(this.props.statusList, (status, key) => {
					return <div className="level-item" key={key}>
						<button className="task-button" onClick={() => this.props.setFilters(status.slug)}>
							<i className={`fa fa-${this.props.selected === status.slug ? 'circle' : 'circle-o'}`} /> {status.title}
						</button>
					</div>
				})}
			</div>
		</div>)
	}
}

TaskNavigation.propTypes = propTypes;

export default TaskNavigation;


// WEBPACK FOOTER //
// ./src/cdm-frontend/elements/widgets/task-navigation.jsx